var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row notifications"},[_c('notifications',{attrs:{"notifications-url":"/data/notifications/all","view-url":"/data/notifications/view-several","dark":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }